import { of as observableOf, Observable } from "rxjs";

import { catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";

import { ProfileService } from "../profile.service";
import { Profile } from "../../../models";

@Injectable()
export class ProfileResolver implements Resolve<Profile> {
  constructor(private profileService: ProfileService, private router: Router) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.profileService.findOne(route.params["username"]).pipe(
      catchError((err) => {
        this.router.navigateByUrl("/error");
        return observableOf(null);
      })
    );
  }
}
